import React from 'react';
import styles from './Badge.module.css';

interface BadgeProps {
  variant?: 'success' | 'warning' | 'error' | 'info' | 'purple' | 'orange' | 'pending' | 'default';
  children: React.ReactNode;
  className?: string;
  dataTestId?: string;
  title?: string;
  ariaLabel?: string;
}

const Badge: React.FC<BadgeProps> = ({
  variant = 'default',
  children,
  className = '',
  dataTestId,
  title,
  ariaLabel
}) => {
  // Map variant to CSS class
  const getVariantClass = () => {
    switch (variant) {
      case 'success':
        return styles.badgeSuccess;
      case 'warning':
        return styles.badgeWarning;
      case 'error':
        return styles.badgeError;
      case 'info':
        return styles.badgeInfo;
      case 'purple':
        return styles.badgePurple;
      case 'orange':
        return styles.badgeOrange;
      case 'pending':
        return styles.badgePending;
      case 'default':
        return styles.badgeDefault;
      default:
        return styles.badgeDefault;
    }
  };

  const badgeClass = `${styles.badge} ${getVariantClass()} ${className}`.trim();

  return (
    <span
      className={badgeClass}
      title={title}
      // ARIA ignores aria-label on a role-less span; role="img" makes the label the accessible name
      role={ariaLabel ? 'img' : undefined}
      aria-label={ariaLabel}
      {...(dataTestId && { 'data-test-id': dataTestId })}
    >
      {children}
    </span>
  );
};

export default Badge;
